<template>
  <div>
    <div id="all-cards-container">

      <div class="rolescard-container">
        <div v-if="userLevel == 'App Admin' || userLevel == 'Super Admin'" class="rolesCard">
          <router-link to="/rolesPage/searchAppAdminApps/viewAppAdminApps">
            <div class="rolesCard-body">
              <div class="rolesCard-picture-container">
                <svg viewBox="0 0 67 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="31.2" height="31.2" rx="2.4" fill="#F0D8A7"/>
                  <rect x="35.1992" width="31.2" height="31.2" rx="2.4" fill="#F3A304"/>
                  <rect y="34.4004" width="31.2" height="31.2" rx="2.4" fill="#F3A304"/>
                  <rect x="35.1992" y="34.4004" width="31.2" height="31.2" rx="2.4" fill="#F0D8A7"/>
                </svg>
              </div>
              <h6>App Admin</h6>
              <p>Create and mange apps</p>
            </div>
          </router-link>
        </div>
        <div v-else class="rolesCard">
          <div id="tooltip-appadmin" class="rolesCard-body">
            <div class="rolesCard-picture-container">
              <svg viewBox="0 0 67 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="31.2" height="31.2" rx="2.4" fill="#F0D8A7"/>
                <rect x="35.1992" width="31.2" height="31.2" rx="2.4" fill="#F3A304"/>
                <rect y="34.4004" width="31.2" height="31.2" rx="2.4" fill="#F3A304"/>
                <rect x="35.1992" y="34.4004" width="31.2" height="31.2" rx="2.4" fill="#F0D8A7"/>
              </svg>
            </div>
            <h6>App Admin</h6>
            <p>Create and mange apps</p>
          </div>
          <b-tooltip target="tooltip-appadmin" variant="danger" placement="topright" triggers="hover">
            <b style="color: black;">You don't have permission to access this feature.</b>
          </b-tooltip>
        </div>
      </div>
      
      <div class="rolescard-container">
        <div v-if="userLevel == 'Specialist' || userLevel == 'Super Admin'" class="rolesCard">
          <router-link to="/specialist">
            <div class="rolesCard-body">
              <div class="rolesCard-picture-container">
                <svg viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M29.7264 37.7067C26.1548 37.7067 22.7295 36.2879 20.204 33.7624C17.6785 31.2369 16.2597 27.8116 16.2597 24.2401V13.4667C16.2597 12.7524 16.5435 12.0673 17.0486 11.5622C17.5537 11.0571 18.2387 10.7734 18.953 10.7734H21.6464C22.3607 10.7734 23.0458 10.4896 23.5509 9.98453C24.056 9.47943 24.3397 8.79437 24.3397 8.08005C24.3397 7.36574 24.056 6.68068 23.5509 6.17558C23.0458 5.67048 22.3607 5.38672 21.6464 5.38672H18.953C16.8101 5.38672 14.7549 6.238 13.2396 7.7533C11.7243 9.26859 10.873 11.3238 10.873 13.4667V24.2401C10.8765 27.2828 11.6185 30.2793 13.0353 32.9721C14.452 35.6649 16.5012 37.9735 19.0069 39.6998C21.4167 41.8202 23.3707 44.408 24.7504 47.3062C26.13 50.2044 26.9066 53.3527 27.033 56.5601C27.033 61.5603 29.0194 66.3557 32.5551 69.8914C36.0907 73.4271 40.8862 75.4134 45.8864 75.4134C50.8866 75.4134 55.682 73.4271 59.2177 69.8914C62.7534 66.3557 64.7397 61.5603 64.7397 56.5601V53.4897C67.2786 52.8341 69.4913 51.2751 70.9629 49.1049C72.4346 46.9347 73.0642 44.3022 72.7338 41.7009C72.4034 39.0997 71.1357 36.7082 69.1682 34.9748C67.2007 33.2414 64.6685 32.2851 62.0464 32.2851C59.4242 32.2851 56.8921 33.2414 54.9246 34.9748C52.9571 36.7082 51.6893 39.0997 51.3589 41.7009C51.0285 44.3022 51.6582 46.9347 53.1298 49.1049C54.6015 51.2751 56.8142 52.8341 59.353 53.4897V56.5601C59.353 60.1316 57.9342 63.5569 55.4087 66.0824C52.8833 68.6079 49.458 70.0267 45.8864 70.0267C42.3148 70.0267 38.8895 68.6079 36.364 66.0824C33.8385 63.5569 32.4197 60.1316 32.4197 56.5601C32.5529 53.3487 33.3379 50.198 34.727 47.2995C36.116 44.4011 38.0801 41.8154 40.4997 39.6998C42.9954 37.9675 45.0342 35.6562 46.4414 32.9638C47.8485 30.2714 48.5823 27.278 48.5797 24.2401V13.4667C48.5797 11.3238 47.7284 9.26859 46.2131 7.7533C44.6978 6.238 42.6427 5.38672 40.4997 5.38672H37.8064C37.0921 5.38672 36.407 5.67048 35.9019 6.17558C35.3968 6.68068 35.113 7.36574 35.113 8.08005C35.113 8.79437 35.3968 9.47943 35.9019 9.98453C36.407 10.4896 37.0921 10.7734 37.8064 10.7734H40.4997C41.214 10.7734 41.8991 11.0571 42.4042 11.5622C42.9093 12.0673 43.193 12.7524 43.193 13.4667V24.2401C43.193 26.0085 42.8447 27.7597 42.168 29.3935C41.4912 31.0274 40.4992 32.5119 39.2488 33.7624C37.9983 35.0129 36.5137 36.0049 34.8799 36.6816C33.246 37.3584 31.4948 37.7067 29.7264 37.7067ZM62.0464 48.4801C60.6177 48.4801 59.2476 47.9125 58.2374 46.9023C57.2272 45.8921 56.6597 44.522 56.6597 43.0934C56.6597 41.6648 57.2272 40.2946 58.2374 39.2844C59.2476 38.2742 60.6177 37.7067 62.0464 37.7067C63.475 37.7067 64.8451 38.2742 65.8553 39.2844C66.8655 40.2946 67.433 41.6648 67.433 43.0934C67.433 44.522 66.8655 45.8921 65.8553 46.9023C64.8451 47.9125 63.475 48.4801 62.0464 48.4801Z" fill="#A8A8A8"/>
                  <mask id="path-2-inside-1_179_8862" fill="white">
                  <path d="M69.5419 42.4004C70.071 42.4004 70.5059 41.9699 70.4427 41.4445C70.293 40.2008 69.8527 39.0048 69.1518 37.9558C68.2727 36.6402 67.0233 35.6149 65.5615 35.0094C64.0997 34.4039 62.4911 34.2454 60.9393 34.5541C59.7019 34.8002 58.5449 35.3345 57.5596 36.1082C57.1434 36.4349 57.1465 37.0469 57.5206 37.421C57.8948 37.7952 58.4979 37.7879 58.9261 37.477C59.634 36.9631 60.4477 36.6057 61.3131 36.4335C62.4933 36.1988 63.7165 36.3193 64.8282 36.7797C65.9398 37.2402 66.89 38.02 67.5585 39.0204C68.0487 39.7541 68.3713 40.5822 68.5085 41.4462C68.5915 41.9688 69.0127 42.4004 69.5419 42.4004Z"/>
                  </mask>
                  <path d="M69.5419 42.4004C70.071 42.4004 70.5059 41.9699 70.4427 41.4445C70.293 40.2008 69.8527 39.0048 69.1518 37.9558C68.2727 36.6402 67.0233 35.6149 65.5615 35.0094C64.0997 34.4039 62.4911 34.2454 60.9393 34.5541C59.7019 34.8002 58.5449 35.3345 57.5596 36.1082C57.1434 36.4349 57.1465 37.0469 57.5206 37.421C57.8948 37.7952 58.4979 37.7879 58.9261 37.477C59.634 36.9631 60.4477 36.6057 61.3131 36.4335C62.4933 36.1988 63.7165 36.3193 64.8282 36.7797C65.9398 37.2402 66.89 38.02 67.5585 39.0204C68.0487 39.7541 68.3713 40.5822 68.5085 41.4462C68.5915 41.9688 69.0127 42.4004 69.5419 42.4004Z" stroke="#D9D9D9" stroke-width="14.4" stroke-linejoin="bevel" mask="url(#path-2-inside-1_179_8862)"/>
                  <ellipse cx="22.1008" cy="8.00078" rx="2.8" ry="3.2" fill="#F3A304"/>
                  <ellipse cx="36.4992" cy="8.00078" rx="2.8" ry="3.2" fill="#F3A304"/>
                </svg>
              </div>
              <h6>Specialist</h6>
              <p>Analyze the acitivity of your children/patients</p>
            </div>
          </router-link>
        </div>
        <div v-else class="rolesCard">
          <div id="tooltip-specialist" class="rolesCard-body">
            <div class="rolesCard-picture-container">
              <svg viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29.7264 37.7067C26.1548 37.7067 22.7295 36.2879 20.204 33.7624C17.6785 31.2369 16.2597 27.8116 16.2597 24.2401V13.4667C16.2597 12.7524 16.5435 12.0673 17.0486 11.5622C17.5537 11.0571 18.2387 10.7734 18.953 10.7734H21.6464C22.3607 10.7734 23.0458 10.4896 23.5509 9.98453C24.056 9.47943 24.3397 8.79437 24.3397 8.08005C24.3397 7.36574 24.056 6.68068 23.5509 6.17558C23.0458 5.67048 22.3607 5.38672 21.6464 5.38672H18.953C16.8101 5.38672 14.7549 6.238 13.2396 7.7533C11.7243 9.26859 10.873 11.3238 10.873 13.4667V24.2401C10.8765 27.2828 11.6185 30.2793 13.0353 32.9721C14.452 35.6649 16.5012 37.9735 19.0069 39.6998C21.4167 41.8202 23.3707 44.408 24.7504 47.3062C26.13 50.2044 26.9066 53.3527 27.033 56.5601C27.033 61.5603 29.0194 66.3557 32.5551 69.8914C36.0907 73.4271 40.8862 75.4134 45.8864 75.4134C50.8866 75.4134 55.682 73.4271 59.2177 69.8914C62.7534 66.3557 64.7397 61.5603 64.7397 56.5601V53.4897C67.2786 52.8341 69.4913 51.2751 70.9629 49.1049C72.4346 46.9347 73.0642 44.3022 72.7338 41.7009C72.4034 39.0997 71.1357 36.7082 69.1682 34.9748C67.2007 33.2414 64.6685 32.2851 62.0464 32.2851C59.4242 32.2851 56.8921 33.2414 54.9246 34.9748C52.9571 36.7082 51.6893 39.0997 51.3589 41.7009C51.0285 44.3022 51.6582 46.9347 53.1298 49.1049C54.6015 51.2751 56.8142 52.8341 59.353 53.4897V56.5601C59.353 60.1316 57.9342 63.5569 55.4087 66.0824C52.8833 68.6079 49.458 70.0267 45.8864 70.0267C42.3148 70.0267 38.8895 68.6079 36.364 66.0824C33.8385 63.5569 32.4197 60.1316 32.4197 56.5601C32.5529 53.3487 33.3379 50.198 34.727 47.2995C36.116 44.4011 38.0801 41.8154 40.4997 39.6998C42.9954 37.9675 45.0342 35.6562 46.4414 32.9638C47.8485 30.2714 48.5823 27.278 48.5797 24.2401V13.4667C48.5797 11.3238 47.7284 9.26859 46.2131 7.7533C44.6978 6.238 42.6427 5.38672 40.4997 5.38672H37.8064C37.0921 5.38672 36.407 5.67048 35.9019 6.17558C35.3968 6.68068 35.113 7.36574 35.113 8.08005C35.113 8.79437 35.3968 9.47943 35.9019 9.98453C36.407 10.4896 37.0921 10.7734 37.8064 10.7734H40.4997C41.214 10.7734 41.8991 11.0571 42.4042 11.5622C42.9093 12.0673 43.193 12.7524 43.193 13.4667V24.2401C43.193 26.0085 42.8447 27.7597 42.168 29.3935C41.4912 31.0274 40.4992 32.5119 39.2488 33.7624C37.9983 35.0129 36.5137 36.0049 34.8799 36.6816C33.246 37.3584 31.4948 37.7067 29.7264 37.7067ZM62.0464 48.4801C60.6177 48.4801 59.2476 47.9125 58.2374 46.9023C57.2272 45.8921 56.6597 44.522 56.6597 43.0934C56.6597 41.6648 57.2272 40.2946 58.2374 39.2844C59.2476 38.2742 60.6177 37.7067 62.0464 37.7067C63.475 37.7067 64.8451 38.2742 65.8553 39.2844C66.8655 40.2946 67.433 41.6648 67.433 43.0934C67.433 44.522 66.8655 45.8921 65.8553 46.9023C64.8451 47.9125 63.475 48.4801 62.0464 48.4801Z" fill="#A8A8A8"/>
                <mask id="path-2-inside-1_179_8862" fill="white">
                <path d="M69.5419 42.4004C70.071 42.4004 70.5059 41.9699 70.4427 41.4445C70.293 40.2008 69.8527 39.0048 69.1518 37.9558C68.2727 36.6402 67.0233 35.6149 65.5615 35.0094C64.0997 34.4039 62.4911 34.2454 60.9393 34.5541C59.7019 34.8002 58.5449 35.3345 57.5596 36.1082C57.1434 36.4349 57.1465 37.0469 57.5206 37.421C57.8948 37.7952 58.4979 37.7879 58.9261 37.477C59.634 36.9631 60.4477 36.6057 61.3131 36.4335C62.4933 36.1988 63.7165 36.3193 64.8282 36.7797C65.9398 37.2402 66.89 38.02 67.5585 39.0204C68.0487 39.7541 68.3713 40.5822 68.5085 41.4462C68.5915 41.9688 69.0127 42.4004 69.5419 42.4004Z"/>
                </mask>
                <path d="M69.5419 42.4004C70.071 42.4004 70.5059 41.9699 70.4427 41.4445C70.293 40.2008 69.8527 39.0048 69.1518 37.9558C68.2727 36.6402 67.0233 35.6149 65.5615 35.0094C64.0997 34.4039 62.4911 34.2454 60.9393 34.5541C59.7019 34.8002 58.5449 35.3345 57.5596 36.1082C57.1434 36.4349 57.1465 37.0469 57.5206 37.421C57.8948 37.7952 58.4979 37.7879 58.9261 37.477C59.634 36.9631 60.4477 36.6057 61.3131 36.4335C62.4933 36.1988 63.7165 36.3193 64.8282 36.7797C65.9398 37.2402 66.89 38.02 67.5585 39.0204C68.0487 39.7541 68.3713 40.5822 68.5085 41.4462C68.5915 41.9688 69.0127 42.4004 69.5419 42.4004Z" stroke="#D9D9D9" stroke-width="14.4" stroke-linejoin="bevel" mask="url(#path-2-inside-1_179_8862)"/>
                <ellipse cx="22.1008" cy="8.00078" rx="2.8" ry="3.2" fill="#F3A304"/>
                <ellipse cx="36.4992" cy="8.00078" rx="2.8" ry="3.2" fill="#F3A304"/>
              </svg>
            </div>
            <h6>Specialist</h6>
            <p>Analyze the acitivity of your children/patients</p>
          </div>
          <b-tooltip target="tooltip-specialist" variant="danger" placement="topright" triggers="hover">
            <b style="color: black;">You don't have permission to access this feature.</b>
          </b-tooltip>
        </div>
      </div>
      
      <div class="rolescard-container">
        <div v-if="userLevel == 'Parent/Caretaker' || userLevel == 'Super Admin'" class="rolesCard">
          <router-link to="/pageNotAvailable">
            <div class="rolesCard-body">
              <div class="rolesCard-picture-container">
                <svg viewBox="0 0 76 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <ellipse cx="8.40919" cy="46.5982" rx="4.58204" ry="6.87306" transform="rotate(37.2213 8.40919 46.5982)" fill="#E1BE78"/>
                  <ellipse cx="4.58204" cy="6.87306" rx="4.58204" ry="6.87306" transform="matrix(-0.796305 0.604895 0.604895 0.796305 36.1562 38.3535)" fill="#E1BE78"/>
                  <path d="M12.7798 30.2476L8.3774 73.0133C8.09927 75.7152 10.2192 78.0645 12.9354 78.0645H34.5097C37.3455 78.0645 39.5004 75.5146 39.0276 72.7184L31.7951 29.9527C31.4223 27.7483 29.513 26.1348 27.2773 26.1348H17.3377C14.9888 26.1348 13.0203 27.911 12.7798 30.2476Z" fill="#F3A304"/>
                  <circle cx="21.6045" cy="19.6436" r="17.1826" fill="#E1BE78" stroke="white" stroke-width="3.05469"/>
                  <ellipse cx="50.3607" cy="55.8084" rx="3.20743" ry="4.81114" transform="rotate(37.2213 50.3607 55.8084)" fill="#E1BE78"/>
                  <ellipse cx="3.20743" cy="4.81114" rx="3.20743" ry="4.81114" transform="matrix(-0.796305 0.604895 0.604895 0.796305 69.7832 50.0371)" fill="#E1BE78"/>
                  <path d="M53.4222 44.3634L50.3405 74.2993C50.1459 76.1907 51.6298 77.8352 53.5311 77.8352H68.6331C70.6182 77.8352 72.1267 76.0503 71.7957 74.093L66.733 44.157C66.472 42.6139 65.1355 41.4844 63.5704 41.4844H56.6128C54.9685 41.4844 53.5906 42.7278 53.4222 44.3634Z" fill="#F0D8A7"/>
                  <circle cx="59.597" cy="36.9407" r="12.0279" fill="#E1BE78" stroke="white" stroke-width="2.13828"/>
                </svg>
              </div>
              <h6>Parent/Caretaker</h6>
              <p>Create and manage apps</p>
            </div>
          </router-link>
        </div>
        <div v-else class="rolesCard">
          <div id="tooltip-parent-caretaker" class="rolesCard-body">
            <div class="rolesCard-picture-container">
              <svg viewBox="0 0 76 79" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="8.40919" cy="46.5982" rx="4.58204" ry="6.87306" transform="rotate(37.2213 8.40919 46.5982)" fill="#E1BE78"/>
                <ellipse cx="4.58204" cy="6.87306" rx="4.58204" ry="6.87306" transform="matrix(-0.796305 0.604895 0.604895 0.796305 36.1562 38.3535)" fill="#E1BE78"/>
                <path d="M12.7798 30.2476L8.3774 73.0133C8.09927 75.7152 10.2192 78.0645 12.9354 78.0645H34.5097C37.3455 78.0645 39.5004 75.5146 39.0276 72.7184L31.7951 29.9527C31.4223 27.7483 29.513 26.1348 27.2773 26.1348H17.3377C14.9888 26.1348 13.0203 27.911 12.7798 30.2476Z" fill="#F3A304"/>
                <circle cx="21.6045" cy="19.6436" r="17.1826" fill="#E1BE78" stroke="white" stroke-width="3.05469"/>
                <ellipse cx="50.3607" cy="55.8084" rx="3.20743" ry="4.81114" transform="rotate(37.2213 50.3607 55.8084)" fill="#E1BE78"/>
                <ellipse cx="3.20743" cy="4.81114" rx="3.20743" ry="4.81114" transform="matrix(-0.796305 0.604895 0.604895 0.796305 69.7832 50.0371)" fill="#E1BE78"/>
                <path d="M53.4222 44.3634L50.3405 74.2993C50.1459 76.1907 51.6298 77.8352 53.5311 77.8352H68.6331C70.6182 77.8352 72.1267 76.0503 71.7957 74.093L66.733 44.157C66.472 42.6139 65.1355 41.4844 63.5704 41.4844H56.6128C54.9685 41.4844 53.5906 42.7278 53.4222 44.3634Z" fill="#F0D8A7"/>
                <circle cx="59.597" cy="36.9407" r="12.0279" fill="#E1BE78" stroke="white" stroke-width="2.13828"/>
              </svg>
            </div>
            <h6>Parent/Caretaker</h6>
            <p>Create and manage apps</p>
          </div>
          <b-tooltip target="tooltip-parent-caretaker" variant="danger" placement="topright" triggers="hover">
            <b style="color: black;">You don't have permission to access this feature.</b>
          </b-tooltip>
        </div>
      </div>

      <div class="rolescard-container">
        <div v-if="userLevel == 'Statistician/Analyst' || userLevel == 'Super Admin'" class="rolesCard">
          <router-link to="/pageNotAvailable">
            <div class="rolesCard-body">
              <div class="rolesCard-picture-container">
                <svg viewBox="0 0 76 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" width="23.1818" height="68.8636" rx="0.681818" fill="#F0D8A7"/>
                  <rect x="26.4082" y="25.2266" width="23.1818" height="43.6364" rx="0.681818" fill="#F3A304"/>
                  <rect x="52.3184" y="15.6816" width="23.1818" height="53.1818" rx="0.681818" fill="#D9D9D9"/>
                </svg>
              </div>
              <h6>Statistician/Analyst</h6>
              <p>Create and manage apps</p>
            </div>
          </router-link>
        </div>
        <div v-else class="rolesCard">
          <div id="tooltip-statistician-analyst" class="rolesCard-body">
            <div class="rolesCard-picture-container">
              <svg viewBox="0 0 76 69" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" width="23.1818" height="68.8636" rx="0.681818" fill="#F0D8A7"/>
                <rect x="26.4082" y="25.2266" width="23.1818" height="43.6364" rx="0.681818" fill="#F3A304"/>
                <rect x="52.3184" y="15.6816" width="23.1818" height="53.1818" rx="0.681818" fill="#D9D9D9"/>
              </svg>
            </div>
            <h6>Statistician/Analyst</h6>
            <p>Create and manage apps</p>
          </div>
          <b-tooltip target="tooltip-statistician-analyst" variant="danger" placement="topright" triggers="hover">
            <b style="color: black;">You don't have permission to access this feature.</b>
          </b-tooltip>
        </div>
      </div>

      <div class="rolescard-container">
        <div v-if="userLevel == 'Organization' || userLevel == 'Super Admin'" class="rolesCard">
          <router-link to="/pageNotAvailable">
            <div class="rolesCard-body">
              <div class="rolesCard-picture-container">
                <svg viewBox="0 0 80 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="36.5514" y="34.483" width="41.3793" height="37.931" stroke="#F0D8A7" stroke-width="4.13793"/>
                  <rect x="44.1387" y="41.3789" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                  <rect x="60.6895" y="41.3789" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                  <rect x="44.1387" y="57.2422" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                  <rect x="60.6895" y="57.2422" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                  <rect width="44.1379" height="74.4828" fill="#F3A304"/>
                  <rect x="8.96484" y="8.96484" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="25.5176" y="8.96484" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="8.96484" y="24.8281" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="25.5176" y="24.8281" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="8.96484" y="40.6895" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="25.5176" y="40.6895" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="8.96484" y="56.5508" width="8.96552" height="8.96552" fill="white"/>
                  <rect x="25.5176" y="56.5508" width="8.96552" height="8.96552" fill="white"/>
                </svg>
              </div>
              <h6>Organization</h6>
              <p>Create and manage apps</p>
            </div>
          </router-link>
        </div>
        <div v-else class="rolesCard">
          <div id="tooltip-organization" class="rolesCard-body">
            <div class="rolesCard-picture-container">
              <svg viewBox="0 0 80 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="36.5514" y="34.483" width="41.3793" height="37.931" stroke="#F0D8A7" stroke-width="4.13793"/>
                <rect x="44.1387" y="41.3789" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                <rect x="60.6895" y="41.3789" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                <rect x="44.1387" y="57.2422" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                <rect x="60.6895" y="57.2422" width="8.96552" height="8.96552" fill="#F0D8A7"/>
                <rect width="44.1379" height="74.4828" fill="#F3A304"/>
                <rect x="8.96484" y="8.96484" width="8.96552" height="8.96552" fill="white"/>
                <rect x="25.5176" y="8.96484" width="8.96552" height="8.96552" fill="white"/>
                <rect x="8.96484" y="24.8281" width="8.96552" height="8.96552" fill="white"/>
                <rect x="25.5176" y="24.8281" width="8.96552" height="8.96552" fill="white"/>
                <rect x="8.96484" y="40.6895" width="8.96552" height="8.96552" fill="white"/>
                <rect x="25.5176" y="40.6895" width="8.96552" height="8.96552" fill="white"/>
                <rect x="8.96484" y="56.5508" width="8.96552" height="8.96552" fill="white"/>
                <rect x="25.5176" y="56.5508" width="8.96552" height="8.96552" fill="white"/>
              </svg>
            </div>
            <h6>Organization</h6>
            <p>Create and manage apps</p>
          </div>
          <b-tooltip target="tooltip-organization" variant="danger" placement="topright" triggers="hover">
            <b style="color: black;">You don't have permission to access this feature.</b>
          </b-tooltip>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "Card",

    data() {

      return {
        userLevel: "",
      };
    },

    mounted() {
      var userLevel = this.$store.getters.getUserLevel;
      this.userLevel = userLevel;
    },
  };
</script>

<style scoped lang="scss">
  @use '../sharedSCSS/globalSharedVariables';
  
  #all-cards-container {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;

    .rolescard-container {
      border: solid #E9E9E9 1px;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 230px;
      height: 317px;
      padding: 1rem;
      box-shadow: 0px 4px 5.2px 0px #0000001F;

      .rolesCard-picture-container {
        display: flex;
        justify-content: center;

        svg {
          width: 100px;
          height: 100px;
          margin-bottom: 1rem;
        }
      }

      h6 {
        font-size: 20px;
        text-align: center;
      }

      p {
        color: #646464;
        font-size: 1rem;
      }

      a {
        color: black;
        text-decoration: none;
      }
    }
  }
</style>
